import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import * as Yup from "yup";
import { toast } from "react-toastify";

const WhilelabelSettingsModel = ({
  whitelabelSettingsMutate,
  whitelabelSettingsLoading,
  setShowWhitelabelSettings,
  selectedData,
}) => {
  const SubmitHandler = (values) => {
    if (!values.template) {
      toast.error("Please enter Template name");
      return;
    }
    if (!values.footer) {
      toast.error("Please enter Footer Name");
      return;
    }
    whitelabelSettingsMutate(values);
  };

  const formik = useFormik({
    initialValues: {
      template: selectedData?.whatsappOnboardingTemplate || "",
      footer: selectedData?.footer || "",
      id: selectedData?.id || "",
    },
    validationSchema: Yup.object().shape({
      template: Yup.string().required("Template is required"),
      footer: Yup.string().required("Footer is required"),
    }),
    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setShowWhitelabelSettings}>
      {whitelabelSettingsLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>Whitelabel Settings</Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="template">Whatsapp Template</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="template"
                      id="template"
                      autoComplete="off"
                      value={formik.values.template}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.template && formik.errors.template && (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.template}
                      </p>
                    )}
                  </FieldWrapper>
                </InputGroup>

              </CombineInputGroup>
            

              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="footer">Whatspp Footer</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="footer"
                      id="footer"
                      autoComplete="off"
                      value={formik.values.footer}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.footer && formik.errors.footer && (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.footer}
                      </p>
                    )}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
            </Wrapper>

            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default WhilelabelSettingsModel;
